import { render, staticRenderFns } from "./highlighted-text.vue?vue&type=template&id=f36dd404&scoped=true&"
import script from "./highlighted-text.vue?vue&type=script&lang=js&"
export * from "./highlighted-text.vue?vue&type=script&lang=js&"
import style0 from "./highlighted-text.vue?vue&type=style&index=0&id=f36dd404&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36dd404",
  null
  
)

export default component.exports